import script from "./ProfileAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileAvatar.vue?vue&type=script&setup=true&lang=js"

import "./ProfileAvatar.vue?vue&type=style&index=0&id=cedbd9f4&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cedbd9f4"]])

export default __exports__